"use strict";

var setActive = function setActive(tracks, siteLanguage) {
  for (var i = 0; i < tracks.length; i++) {
    var trackLanguage = tracks[i].language.substr(0, 2);
    if (trackLanguage) {
      if (trackLanguage === siteLanguage) {
        tracks[i].hasOwnProperty("mode") ? tracks[i].mode = "showing" : tracks[i].enabled = true;
      } else if (tracks[i].hasOwnProperty("mode")) {
        tracks[i].mode = "disabled";
      }
    }
  }
};
var setButtonPause = function setButtonPause(btn) {
  if (btn) {
    btn.classList.toggle("paused");
    btn.setAttribute('aria-label', 'Pause background video');
  }
};
var setButtonPlay = function setButtonPlay(btn) {
  if (btn) {
    btn.classList.toggle("paused");
    btn.setAttribute('aria-label', 'Play background video');
  }
};
(function () {
  window.addEventListener("brightcoveloaded", function (e) {
    var selector = '.brightcove_player__video';
    var videos = document.querySelectorAll(selector);
    videos.forEach(function (video) {
      if (bc) {
        var player = bc(video);
        var btn = null;
        if (video.dataset.pauseButton) {
          btn = document.getElementById("ac-btn-".concat(video.dataset.videoId));
          if (btn) {
            btn.addEventListener('click', function (e) {
              var paused = player.paused();
              if (paused) {
                player.play();
                setButtonPause(btn);
              } else {
                player.pause();
                setButtonPlay(btn);
              }
            });
          }
        }
        player.ready(function () {
          if (video.dataset.audioOnly) {
            player.audioOnlyMode(true);
          }
          if (video.dataset.role) {
            video.setAttribute('role', video.dataset.role);
            video.querySelectorAll('[role]').forEach(function (e) {
              e.setAttribute('role', video.dataset.role);
            });
          }
        });
        player.on("loadedmetadata", function () {
          if (player.autoplay() && !player.viewability().state.viewable) {
            player.pause();
          }
          var siteLanguage = video.dataset.language || "en-US";
          siteLanguage = siteLanguage.substr(0, 2);
          var audioTracks = player.audioTracks();
          setActive(audioTracks, siteLanguage);
          var textTracks = player.textTracks();
          setActive(textTracks, siteLanguage);
        });
        player.on('viewable-change', function (e) {
          if (e.viewable && player.autoplay()) {
            player.play();
            setButtonPause(btn);
          } else if (player.autoplay()) {
            player.pause();
            setButtonPlay(btn);
          }
        });
      }
    });
    document.querySelectorAll('video, video-js').forEach(function (el) {
      el.removeAttribute('role');
    });
  });
})();